// Copyright 2018 Sisense Inc. All rights reserved.

/**
 * @fileoverview The event object dispatched when the history changes.
 * @author artem.lit@sisense.com (Artem Lytvynov)
 * @copyright sisense@sisense.com (Sisense Ltd.)
 * @license Sisense License
 */

'use strict';

const Event = require('@sbi/core.events').Event;

/**
 * Event object dispatched after the history state has changed.
 * @param {string} token The string identifying the new history state.
 * @param {boolean} isNavigation True if the event was triggered by a
 * browser action, such as forward or back, clicking on a link, editing
 * the URL, or calling {@code window.history.(go|back|forward)}. False
 * if the token has been changed by a {@code setToken} or
 * {@code replaceToken} call.
 * @param {Html5History} target
 * @extends {Event}
 * @final
 */
class HistoryChanged extends Event {
    /**
     * Class constructor.
     * @param {string} token The string identifying the new history state.
     * @param {boolean} isNavigation True if the event was triggered by a
     * browser action, such as forward or back, clicking on a link, editing
     * the URL, or calling {@code window.history.(go|back|forward)}. False
     * if the token has been changed by a {@code setToken} or
     * {@code replaceToken} call.
     * @param {Html5History} target
     * @constructor
     */
    constructor(token, isNavigation, target) {
        // noinspection JSCheckFunctionSignatures
        super('historychanged', target);

        // noinspection JSUnusedGlobalSymbols
        /**
         * The current history state.
         * @type {string}
         */
        this.token = token;

        // noinspection JSUnusedGlobalSymbols
        /**
         * Whether the event was triggered by browser navigation.
         * @type {boolean}
         */
        this.isNavigation = isNavigation;
    }
}

// Exports:
exports.HistoryChanged = HistoryChanged;
